// extracted by mini-css-extract-plugin
export default {"card":"T1-z","carouselContainer":"U1-z","carouselContent":"V1-z"};